import { ElementRef, EventEmitter, } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * Emits if the user clicks outside the host element.
 */
export class OutsideClickDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.outsideClick = new EventEmitter();
    }
    onClick(event) {
        const mouseEvent = event;
        if (!this.elementRef.nativeElement.contains(mouseEvent.target)) {
            this.outsideClick.emit(mouseEvent);
        }
    }
}
OutsideClickDirective.ɵfac = function OutsideClickDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OutsideClickDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
OutsideClickDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: OutsideClickDirective, selectors: [["", "flOutsideClick", ""], [""]], hostBindings: function OutsideClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mousedown", function OutsideClickDirective_mousedown_HostBindingHandler($event) { return ctx.onClick($event); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { outsideClick: "outsideClick" }, standalone: true });
